module.exports = __webpack_public_path__ + "static/media/chat-bubbles-with-ellipsis.afac159f.svg";